import { t, translate } from '@avalara/bat-apps-shared/i18n';
import { SIcon } from '@avalara/skylab-sdk/react';

import type { PartnerSignupInfo } from '@avalara/types/reducer-states';
import ExternalLink from '../external-link';
import { CheckedUL } from '../styled/components/sign-up';
import { Info } from '../styled/skylab/box';
import ThirdBulletContent from './third-bullet';

type Props = {
  isDirectToBuy?: boolean;
  partnerSignup?: PartnerSignupInfo;
  start: boolean;
  showThirdBullet: boolean;
};

const CheckoutPurchaseInfo = ({ isDirectToBuy = false, partnerSignup, start, showThirdBullet }: Props) => (
  <>
    <div>
      <Info>
        {!start ? (
          <>
            <p data-ref='buy.signup.start.info-content'>
              {t('client.general.well-set-up-your-first-company')}
              <br />
              {t('client.general.you-can-add-additional-companies-later')}
            </p>
            <p>{t('client.general.well-use-your-business-address-to-set-up-default-tax-calculation-in-avatax')}</p>
            <p>{t('client.general.you-can-make-changes-and-add-additional-jurisdictions-later')}</p>
          </>
        ) : (
          <>
            <h3 data-ref='buy.signup.start.header' className='alt text-center text-md'>
              {"What's included?"}
            </h3>
            <CheckedUL>
              <li data-ref='buy.signup.list-item-one'>
                <SIcon name='check' />
                {t('client.general.full-access-to-avatax')}
              </li>
              <li data-ref='buy.signup.list-item-two'>
                <SIcon name='check' />
                API use and data import ability
              </li>
              {window.location.href.indexOf('partner') === -1 && (
                <li data-ref='buy.signup.list-item-partner'>
                  <SIcon name='check' />
                  {t('client.general.limited-number-of-connectors')}
                </li>
              )}
              {!isDirectToBuy && showThirdBullet && (
                <li data-ref='buy.signup.list-item-third'>
                  <SIcon name='check' />
                  <ThirdBulletContent partnerSignup={partnerSignup} />
                </li>
              )}
            </CheckedUL>
          </>
        )}
      </Info>
      {!isDirectToBuy && (
        <div className='margin-top-lg pad-left-lg' style={{ color: 'initial' }}>
          <p>{t('client.general.have-questions-about-the-avatax-free-trial')}</p>
          <p>
            {translate('client.general.check-out-our-faqs', {
              faqsLink: (chunks) => (
                <ExternalLink
                  data-ref='buy.signup.faq.link'
                  href='https://help.avalara.com/Frequently_Asked_Questions/Avalara_AvaTax_Update_FAQ/Avalara_AvaTax_Free_Trial_Frequently_Asked_Questions'
                  alwaysOpenInNewTab
                >
                  {chunks}
                </ExternalLink>
              ),
            })}
          </p>
        </div>
      )}
    </div>
    <div />
  </>
);
export default CheckoutPurchaseInfo;
